import React from 'react';
import { RangeGrowth, WhereUsers, DepositGrowth, AverageAmount, AverageLength } from '../components.js';

class HomeMain extends React.Component {


	constructor(props) {
		super(props);

		this.subviewClick = this.subviewClick.bind(this);
	}

	subviewClick(e) {
		
		if(this.props.subviewClick) this.props.subviewClick(e);
	}

	routeToUsers(e) {
		window.location.href = '/Users';
	}

	routeToGoals(e) {
		window.location.href = '/Goals';
	}

	render () {
		const arContainerSize = {
		    width : '62vmin',
		    height: 'auto'
		  };

		const whereContainerSize = {
		  	width : '58vmin',
		  	height: 'auto'
		};

		const averages = {
			width : '26.5vmin',
			height: 'auto'
		}

	  	return (
	  		<div className="App-HomeBoxes">
	            <div className="App-HomeBoxRow1">
	              	<RangeGrowth size={arContainerSize} addClass="Clickable" onclick={this.routeToUsers} />
	              	<WhereUsers size={whereContainerSize} addClass="Clickable" heatmap={'heatmap'} onclick={this.routeToUsers} subview={false} subviewClick={this.subviewClick} />
	            </div>
	            <div className="App-HomeBoxRow1">
	            	<DepositGrowth size={arContainerSize} addClass="Clickable" onclick={this.routeToGoals} />
	            	<AverageAmount size={averages} addClass="Clickable" onclick={this.routeToGoals} />
	            	<AverageLength size={averages} addClass="Clickable" onclick={this.routeToGoals} />
	            </div>
	         </div>
	  	);
	}
}




export default HomeMain;

